// extracted by mini-css-extract-plugin
module.exports = {"highlights":"highlights_highlights__X69Rw"};